// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import "babel-polyfill"
// import VueRouter from 'vue-router'
import axios from 'axios';
import "../static/css/main.css";
// import "../static/css/override-element-ui.css"; //重写样式
import ElementUI from 'element-ui';
import auth from "@/utils/auth";
import 'element-ui/lib/theme-chalk/index.css'; // 默认主题
import "../static/icon/iconfont.css";
Vue.config.productionTip = false

Vue.prototype.isContainUndefined = function(url) {
    if (!url) {
      return false
    }
    return url.indexOf('undefined') == -1 // 如果包含就是true
  }

  Vue.prototype.isContainUndefinedAnd = function(url) {
    if (!url) {
      return false
    }
    //   console.log((url.indexOf('undefined') == -1 && url.indexOf('无资料请上传本图') == -1), 2111)
  
    return (url.indexOf('undefined') == -1 && url.indexOf('无资料请上传本图') == -1&&
    url.indexOf('null') == -1 &&
    url != '') // 如果不包含就是true
  }
  
Vue.use(ElementUI, {
  size: 'small'
});
// Vue.use(VueRouter);
//----------------添加拦截器-------------------------------------------
axios.create({
  headers: 'token'
});

axios.interceptors.request.use(
  config => {
      let token = auth.getToken();
      if (token) { // 判断是否存在token，如果存在的话，则每个http header都加上token
          config.headers['token'] = `${token}`;
      }
      return config;
  },
  err => {
      return Promise.reject(err);
  });
// 添加响应拦截器
axios.interceptors.response.use(function(response) {
  // // 对响应数据做点什么
//   alert(JSON.stringify(response));
  if (response.code == 10000) {
      auth.removeToken();
      router.replace('/login');
      return Promise.reject(response.data);
  } else {
      return response;
  }


}, function(error) {
  // 对响应错误做点什么
  return Promise.reject(error);
});
axios.defaults.withCredentials = true; //意思是携带cookie信息,保持session的一致性
Vue.prototype.$axios = axios;

Vue.prototype.isContainUndefinedAnd = function(url) {
    if (!url) {
      return false
    }
    //   console.log((url.indexOf('undefined') == -1 && url.indexOf('无资料请上传本图') == -1), 2111)
  
    return (url.indexOf('undefined') == -1 && url.indexOf('无资料请上传本图') == -1) // 如果不包含就是true
  }

//使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {
  var token = auth.getToken();
  if (!token && to.path == "") {
      next('/login');
  } else
  if (!token && to.path == "/404" && to.path == "/zhuce"&& to.path == "/zhengce"&& to.path == "/xieyi"&& to.path == "/forgetPwd"&& to.path == "/nongmingongXuzhi") {
      next();
  } else if (!token && to.path !== '/login' && to.path != "/zhuce"&& to.path != "/zhengce"&& to.path != "/xieyi"&& to.path != "/forgetPwd"&& to.path != "/nongmingongXuzhi") {
      next('/login');
  } else if (to.meta.permission) {
      // 如果是管理员权限则可进入，这里只是简单的模拟管理员权限而已
      //role === 'admin' ? next() : next('/403');
      next();
  } else {
      // 简单的判断IE10及以下不进入富文本编辑器，该组件不兼容
      if (navigator.userAgent.indexOf('MSIE') > -1 && to.path === '/editor') {
          Vue.prototype.$alert('vue-quill-editor组件不兼容IE10及以下浏览器，请使用更高版本的浏览器查看', '浏览器不兼容通知', {
              confirmButtonText: '确定'
          });
      } else {
          next();
      }
  }
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js